import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AxiosError } from 'axios';

import { AuthService, mfaRequiredSchema } from 'src/app/shared/services/auth/auth.service';
import { UsersService } from '../users/users.service';


@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {
  private router = inject(Router);
  private authService = inject(AuthService);
  private usersService = inject(UsersService);

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    const user = this.usersService.userSubject.value;
    if (user) {
      this.authService.setNext(null);
      return true;
    }

    this.authService.setNext(state.url);

    this.authService.logoutOnUnauthorized = false;
    try {
      await this.usersService.setUser();
      this.authService.setNext(null);
      this.authService.logoutOnUnauthorized = true;
      return true;
    } catch (error) {
      if (error instanceof AxiosError && mfaRequiredSchema.safeParse(error.response?.data).success) {
        this.authService.logoutOnUnauthorized = true;
        return this.router.navigateByUrl('2fa/verify');
      }
    }

    this.authService.logoutOnUnauthorized = true;

    return this.router.navigateByUrl('login');
  }
}
